import { render, staticRenderFns } from "./MCQ.vue?vue&type=template&id=70810080&"
import script from "./MCQ.vue?vue&type=script&lang=js&"
export * from "./MCQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports